module.exports = __webpack_public_path__ + "static/media/editar.5e74b73c.svg";